import React from "react";
import { Story4Style } from "./css/Story4Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const story_4 = (props) => {
  return (
    <Story4Style>
      <div className="poster flex-column">
        <div className="poster-content">
          <div className="logo-container flex-column">
            <OutroLogo logo={props.file} />
          </div>
          <div className="text-wrapper flex-column">
            <OutroText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Story4Style>
  );
};

export default story_4;
